export default __webpack_public_path__ + "static/media/undo.6346b049.svg";